import { useSelector } from 'react-redux';
import { selectPlan } from '../store/authSlice';

// ── Plan hierarchy ────────────────────────────────────────────────────────────
const PLAN_RANK = { starter: 1, pro: 2 };

export const usePlan = () => {
  const plan = useSelector(selectPlan);
  const rank = PLAN_RANK[plan] || 1;
  return {
    plan,
    isStarter: plan === 'starter',
    isPro:     plan === 'pro',
    canAccess: (required) => rank >= (PLAN_RANK[required] || 1),
  };
};